__turbopack_context__.v({
  "className": "caveat_9c8cf7c5-module__vEugma__className",
});
